import { PlainModal } from '@design-system/components/modal/modal';
import guideStepLearnImage from '/static/images/guide-step-learn.png';

type ExamplesModalProps = {
  isOpen: boolean;
  close: () => void;
};

export const ExamplesModal = ({ isOpen, close }: ExamplesModalProps) => {
  return (
    <PlainModal isOpen={isOpen} onClose={close} modalClassName="w-[900px]">
      <div className="flex justify-center items-center">
        <img src={guideStepLearnImage}></img>
      </div>
    </PlainModal>
  );
};
